import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'

import { useLazyQuery } from '@apollo/client'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import { payload } from '@shared/libs/category'
import { isBottomReached } from '@shared-submodule/utils'
import { articleLoader } from '@shared/libs/allLoader'
import { LIST_CATEGORY_WISE_VIDEO } from '@graphql/videos/videos.query'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import CustomLink from '@shared/components/customLink'
const ArticleGrid = dynamic(() => import('@shared/components/article/articleGrid'), { loading: () => articleLoader(['g']) })

const CategoryVideos = ({ data, nTotal }) => {
  const [videosData, setVideosData] = useState(data)
  const loading = useRef(false)
  const payloadVideos = useRef({ ...payload(3) })
  const total = useRef(nTotal)

  const [getCategoryVideo, { data: categoryVideo }] = useLazyQuery(LIST_CATEGORY_WISE_VIDEO)

  useEffect(() => {
    if (videosData?.length) {
      loading.current = false
      isBottomReached(videosData[videosData?.length - 1]?._id, isReached)
    }
  }, [videosData])

  useEffect(() => {
    const value = categoryVideo?.listCategoryWiseVideo
    if (value) {
      total.current = value?.oVideos?.nTotal
      setVideosData([...videosData, ...value?.aResults])
    }
  }, [categoryVideo])

  async function isReached(reach) {
    if (reach && !loading.current && videosData?.length < total.current) {
      loading.current = true
      setPayload()
      getMoreData()
    }
  }

  async function getMoreData() {
    const { data } = await getCategoryVideo({ variables: { input: { ...payloadVideos.current } } })
    return data?.listCategoryWiseVideo?.aResults
  }

  function setPayload() {
    payloadVideos.current = { ...payloadVideos.current, nSkip: payloadVideos.current.nSkip + 1 }
  }
  return (
    <>
      {
        videosData?.map((category, index) => {
          return (
            <section key={category?._id} id={category?._id} className={`${index > 0 ? ' mt-2 mt-md-4' : ''}`}>
              <div className={'mb-3 d-flex justify-content-between align-items-center'}>
                {
                  category?.aVideos.length > 0 && (
                    <>
                      <h5 className="mb-0">{category?.sName}</h5>
                      {category?.aVideos.length > 3 && (
                        <CustomLink href={`/${category?.oSeo?.sSlug}/${category?.oCategory?.eType === 's' ? '?tab=videos' : category?.oSeo?.eType !== 'pl' ? `${allRoutes.cricketVideo}` : ''}`} prefetch={false}>
                          <a className={`theme-btn nobg-btn border-0 ${styles.viewAllVideos}`}>
                            View All
                          </a>
                        </CustomLink>
                      )}
                    </>
                  )
                }
              </div>
              <Row className={`${styles.articleGridList} d-none d-md-flex scroll-list article-grid-list`}>
                {
                  category?.aVideos?.map((video, ind) => {
                    if (ind < 3) {
                      return (
                        <Col key={video?._id} lg={4} sm={12}>
                          <ArticleGrid isVideo={true} data={video} isFullCard videoThumbnail={video?.aThumbnails[video?.aThumbnails.length - 1]?.sUrl} />
                        </Col>
                      )
                    } else {
                      return <></>
                    }
                  })
                }
              </Row>
              <div className="d-md-none position-relative">
                <div className="scrollable-wrapper scroll-list">
                  <div className="d-inline-flex gap-4">
                    {category?.aVideos.slice(0, 5).map((item, index) => {
                      const thumbnailUrl = item?.aThumbnails[item?.aThumbnails.length - 1]?.sUrl
                      return (
                        <div
                          key={`mobile-article-${index}`}
                          style={{
                            width: '280px',
                            flex: '0 0 auto'
                          }}>
                          <ArticleGrid isVideo={true} data={item} videoThumbnail={thumbnailUrl} />
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </section>
          )
        })
      }
    </>
  )
}

CategoryVideos.propTypes = {
  data: PropTypes.array,
  nTotal: PropTypes.number
}

export default CategoryVideos
